/**
 * TableRow Component
 * Encapsulated TableRow with consistent hover styling
 */

import React from 'react';
import { TableRow as MuiTableRow, TableRowProps as MuiTableRowProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface TableRowProps extends MuiTableRowProps {
  // Inherits all MuiTableRow props
}

export const TableRow: React.FC<TableRowProps> = ({ 
  sx,
  children,
  ...props 
}) => {
  const theme = useTheme();
  
  const defaultStyles = {
    '&:hover': {
      backgroundColor: theme.customColors.tableRowHover,
    },
    '&:hover .sticky-table-cell': {
      backgroundColor: theme.customColors.tableRowHover,
    },
    '&:last-child td': {
      borderBottom: 0,
    },
  };

  return (
    <MuiTableRow
      sx={{
        ...defaultStyles,
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiTableRow>
  );
};

